import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
import { fireOperationalEvent } from '@atlassian/teams-common/analytics';

import { AnalyticsAction, AnalyticsActionSubject } from './index';

export const triggerAnalyticsForLoadedPeople = (
	action: 'failed' | 'succeeded',
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
	status?: number,
	error?: Error,
) => {
	fireOperationalEvent(createAnalyticsEvent, {
		actionSubject: AnalyticsActionSubject.PEOPLE_MENU_LINK,
		action: action === 'succeeded' ? AnalyticsAction.SUCCEEDED : AnalyticsAction.FAILED,
		attributes: {
			status,
			error: error?.message || JSON.stringify(error),
		},
	});
};

export const triggerAnalyticsForLoadedTeam = (
	action: 'failed' | 'succeeded',
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
	status?: number,
	error?: Error,
) => {
	fireOperationalEvent(createAnalyticsEvent, {
		actionSubject: AnalyticsActionSubject.TEAM_MENU_LINK,
		action: action === 'succeeded' ? AnalyticsAction.SUCCEEDED : AnalyticsAction.FAILED,
		attributes: {
			status,
			error: error?.message || JSON.stringify(error),
		},
	});
};
